import type { InferType } from 'form';
import { useTranslation } from 'i18n';
import { CircularProgress, Page, Section, Typography } from 'ui';
import { AddBoxOutlined } from 'ui/icons';

import { MaterialProductUpdateForm } from '../../components/MaterialProductUpdateForm/MaterialProductUpdateForm';
import { useGetMaterialProductDetails } from '../../hooks/useGetMaterialProductDetails/useGetMaterialproductDetails';
import type { MaterialProductSchema } from '../schema';

export type UpdateFormValues = InferType<typeof MaterialProductSchema>;

export const MaterialProductDetails = () => {
  const { t } = useTranslation('orders');
  const materialProductDetails = useGetMaterialProductDetails();

  return (
    <Page>
      <Section title={t('materialProducts.form.title')} icon={AddBoxOutlined}>
        {materialProductDetails.isLoading ? <CircularProgress /> : null}
        {!materialProductDetails.isLoading && materialProductDetails.data ? (
          <MaterialProductUpdateForm
            materialProductData={materialProductDetails.data}
            materialProductId={Number(materialProductDetails.id)}
          />
        ) : null}
        {!materialProductDetails.isLoading && !materialProductDetails.data && (
          <Typography>{t('materialProducts.details.notFound')}</Typography>
        )}
      </Section>
    </Page>
  );
};
